import { TAX_RATE } from '@finn/ua-constants';
import { useDownPayment } from '@finn/ua-featureflags';
import { useForBusinessCookie } from '@finn/ua-vehicle';
import { useMemo } from 'react';

import { FiltersResponse } from '../../core';

export const useCheapestPrices = (
  isPlpAdvancedGrouping: boolean,
  availableFilters?: FiltersResponse
) => {
  const { isDownPaymentEnabled } = useDownPayment();
  const isForBusiness = useForBusinessCookie();

  return useMemo(() => {
    const map: Record<
      string,
      { cheapestPrice: number; versionsCount: number }
    > = {};

    if (!isPlpAdvancedGrouping) return map;

    availableFilters?.brands.forEach((brand) => {
      brand.models.forEach(
        ({
          cheapest_downpayment_price,
          cheapest_price,
          versions_count,
          id: modelId,
        }) => {
          let cheapestPrice = isDownPaymentEnabled
            ? cheapest_downpayment_price
            : cheapest_price;

          // Only for PoC purpose
          if (isForBusiness) {
            cheapestPrice = cheapestPrice / (1 + TAX_RATE);
          }

          map[`${brand.id}::${modelId}`] = {
            cheapestPrice,
            versionsCount: versions_count ?? 1,
          };
        }
      );
    });

    return map;
  }, [
    isPlpAdvancedGrouping,
    availableFilters,
    isDownPaymentEnabled,
    isForBusiness,
  ]);
};
